export function uuid(): string {
  return Date.now() + (Math.random() * 10000).toFixed();
}

export function copy<T>(object: T): T {
  return JSON.parse(JSON.stringify(object));
}

export function isDefined(value: any): boolean {
  return value !== undefined && value !== null;
}

/**
 * To prevent spamming click
 * @param debounceTime Time before method execution
 * @returns
 */
export function Debounce(debounceTime?: number) {
  let timeout = null as any;
  return function (
    target: Object,
    key: string | Symbol,
    descriptor: PropertyDescriptor
  ) {
    const value = descriptor.value;
    descriptor.value = function (...args: any[]) {
      clearTimeout(timeout);
      timeout = setTimeout(() => {
        return value.apply(this, args);
      }, debounceTime || 500);
    };
  };
}
